/**
 * @generated SignedSource<<ae117748779f0c7783820a0805a50c16>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileHeaderBreadcrumbs_tradeFirm$data = {
  readonly name: string | null;
  readonly " $fragmentType": "ProfileHeaderBreadcrumbs_tradeFirm";
};
export type ProfileHeaderBreadcrumbs_tradeFirm$key = {
  readonly " $data"?: ProfileHeaderBreadcrumbs_tradeFirm$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileHeaderBreadcrumbs_tradeFirm">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileHeaderBreadcrumbs_tradeFirm",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "TradeFirmType",
  "abstractKey": null
};

(node as any).hash = "748bb967227fc1a338ffaace8c071d34";

export default node;
